// let closeCarouselProductBtns = document.querySelectorAll(".close-what-you-need__product__mobile-popup-btn");
// let openCarouselProductBtns = document.querySelectorAll(".mobile-dot-btn");
// let carouselPopups = document.querySelectorAll(".what-you-need__product__mobile-popup");

// function toggleCarouselPopup(popup) {
//     popup.getAttribute("aria-hidden") == "true" ? popup.setAttribute("aria-hidden", "false") : popup.setAttribute("aria-hidden", "true");
// }

// for (let i = 0; i < 4; i++) {
//     openCarouselProductBtns[i].addEventListener("click", function() {
//         toggleCarouselPopup(carouselPopups[i])
//     });
//     closeCarouselProductBtns[i].addEventListener("click", function() {
//         toggleCarouselPopup(carouselPopups[i])
//     });
// }

document.addEventListener("DOMContentLoaded", function() {
    let closeCarouselProductBtns = document.querySelectorAll(".close-what-you-need__product__mobile-popup-btn");
    let openCarouselProductBtns = document.querySelectorAll(".mobile-dot-btn");
    let carouselPopups = document.querySelectorAll(".what-you-need__product__mobile-popup");


    function toggleCarouselPopup(popup) {
        let isHidden = popup.getAttribute("aria-hidden") === "true"; popup.setAttribute("aria-hidden", isHidden ? "false" : "true");
    }


    openCarouselProductBtns.forEach((btn, index) => {
        btn.addEventListener("click", function() {
            if (carouselPopups[index]) {
                toggleCarouselPopup(carouselPopups[index]);
            }
        });
    });

    
    closeCarouselProductBtns.forEach((btn, index) => {
        btn.addEventListener("click", function() {
            if (carouselPopups[index]) {
                toggleCarouselPopup(carouselPopups[index]);
            }
        });
    });
});